/**
 * Набор системных иконок Meratech. Источники — три раздела кита:
 *   ui-kit/Meratech UI Kit.dc.html      строки 908-984  — «05 · Системные иконки»
 *   ui-kit/Meratech Navigation.dc.html  строки 213-227  — карта путей this.I
 *   ui-kit/Meratech Feedback.dc.html    строки 188-197  — карта путей this.I
 *
 * Общая геометрия: viewBox 24, fill none, stroke currentColor, скруглённые концы —
 * задаётся в Icon.module.css, а не в каждом пути.
 *
 * Окружности кита (<circle cx cy r>) переписаны двумя дугами в том же пути, чтобы весь
 * глиф был одной строкой: M(cx-r) cy A r r 0 1 0 (cx+r) cy A r r 0 1 0 (cx-r) cy Z.
 *
 * Расхождения с китом зафиксированы в docs/ui-kit/contracts/icon.md.
 * Внешние библиотеки иконок не подключаются (решение Q10 в docs/ui-kit/inventory.md).
 */
export const ICON_PATHS = {
  // ── Разделы системы ────────────────────────────────────────────────────────
  home: 'M4.4 10.6 L12 4.2 L19.6 10.6 V19 A1 1 0 0 1 18.6 20 H5.4 A1 1 0 0 1 4.4 19 Z',
  grid: 'M4.4 4.4 H10.4 V10.4 H4.4 Z M13.6 4.4 H19.6 V10.4 H13.6 Z M4.4 13.6 H10.4 V19.6 H4.4 Z M13.6 13.6 H19.6 V19.6 H13.6 Z',
  // Тележка, а не сумка кита: сумка на 16px читалась урной рядом с `trash` (расхождения — icon.md)
  cart: 'M2.8 4.2 H5.1 L7.3 15.2 H17.6 L19.8 7.6 H6.1 M7.6 19 A1.4 1.4 0 1 0 10.4 19 A1.4 1.4 0 1 0 7.6 19 Z M15 19 A1.4 1.4 0 1 0 17.8 19 A1.4 1.4 0 1 0 15 19 Z',
  doc: 'M6.6 4.7 H14.2 L18.4 8.9 V19.3 A1.9 1.9 0 0 1 16.5 21.2 H6.6 A1.9 1.9 0 0 1 4.7 19.3 V6.6 A1.9 1.9 0 0 1 6.6 4.7 Z M13.9 4.9 V9.2 H18.2 M8.4 16.6 H14.6',
  folder:
    'M3.6 6.6 A1.6 1.6 0 0 1 5.2 5 H9.4 L11.4 7.4 H18.8 A1.6 1.6 0 0 1 20.4 9 V17.4 A1.6 1.6 0 0 1 18.8 19 H5.2 A1.6 1.6 0 0 1 3.6 17.4 Z',
  truck:
    'M2.8 7.4 H13.4 V16.6 H2.8 Z M13.4 10.4 H17.6 L20.6 13.2 V16.6 H13.4 Z M5.2 18.4 A1.8 1.8 0 1 0 8.8 18.4 A1.8 1.8 0 1 0 5.2 18.4 Z M15 18.4 A1.8 1.8 0 1 0 18.6 18.4 A1.8 1.8 0 1 0 15 18.4 Z',
  box: 'M4.6 8.2 L12 4.4 L19.4 8.2 V16 L12 19.8 L4.6 16 Z M4.6 8.2 L12 12 L19.4 8.2 M12 12 V19.8',
  chart: 'M5 19 V11 M12 19 V5.6 M19 19 V14',
  users:
    'M8.6 11.4 A3.2 3.2 0 1 0 8.6 5 A3.2 3.2 0 0 0 8.6 11.4 Z M3.4 19.6 C3.4 16.4 5.7 14.2 8.6 14.2 C11.5 14.2 13.8 16.4 13.8 19.6 M16 5.4 A3 3 0 0 1 16 11.2 M17.4 14.4 C19.4 15.2 20.6 17 20.6 19.6',
  // Кит рисует одиночную фигуру смещённой влево (центр 8.6) — это левый человек из пары users.
  // Отдельная иконка обязана быть отцентрована, поэтому все x сдвинуты на +3.4.
  user: 'M12 11.4 A3.2 3.2 0 1 0 12 5 A3.2 3.2 0 0 0 12 11.4 Z M6.8 19.6 C6.8 16.4 9.1 14.2 12 14.2 C14.9 14.2 17.2 16.4 17.2 19.6',
  scale:
    'M12 4.6 V20.4 M7.4 20.4 H16.6 M4.2 8.4 H19.8 M4.2 8.4 L6.9 14.2 H1.5 Z M19.8 8.4 L22.5 14.2 H17.1 Z',
  bell: 'M6.4 10.2 A5.6 5.6 0 0 1 17.6 10.2 V15 L19.4 17.8 H4.6 L6.4 15 Z M10 20.4 A2.3 2.3 0 0 0 14 20.4',
  gear: 'M20.77 9.98 L20.77 14.02 L18.01 14.19 L17.80 14.70 L19.63 16.77 L16.77 19.63 L14.70 17.80 L14.19 18.01 L14.02 20.77 L9.98 20.77 L9.81 18.01 L9.30 17.80 L7.23 19.63 L4.37 16.77 L6.20 14.70 L5.99 14.19 L3.23 14.02 L3.23 9.98 L5.99 9.81 L6.20 9.30 L4.37 7.23 L7.23 4.37 L9.30 6.20 L9.81 5.99 L9.98 3.23 L14.02 3.23 L14.19 5.99 L14.70 6.20 L16.77 4.37 L19.63 7.23 L17.80 9.30 L18.01 9.81 Z M8.7 12 A3.3 3.3 0 1 0 15.3 12 A3.3 3.3 0 1 0 8.7 12 Z',
  // В ките глифа нет: раздел «Проверка серийных номеров» (гарантийная проверка) получил щит
  // с галочкой — тот же язык «проверено», что у `check`/`cartCheck`. Геометрия на сетке 24.
  shield:
    'M12 3.4 L18.8 6 V11 C18.8 15.4 15.9 18.7 12 20.6 C8.1 18.7 5.2 15.4 5.2 11 V6 Z M9 11.8 L11.1 13.9 L15 9.6',
  // В ките глифа нет: раздел «Сборка ПК» получил процессор — корпус микросхемы с кристаллом
  // внутри и выводами по четырём сторонам, тот же язык «из компонентов». Геометрия на сетке 24.
  cpu: 'M7 7 H17 V17 H7 Z M10 10 H14 V14 H10 Z M9.5 7 V4.5 M14.5 7 V4.5 M9.5 17 V19.5 M14.5 17 V19.5 M7 9.5 H4.5 M7 14.5 H4.5 M17 9.5 H19.5 M17 14.5 H19.5',

  // ── Действия ───────────────────────────────────────────────────────────────
  search: 'M4.7 10.4 A5.7 5.7 0 1 0 16.1 10.4 A5.7 5.7 0 1 0 4.7 10.4 Z M14.6 14.6 L20.6 20.6',
  filter: 'M4 6.4 H20 L13.7 13.9 V19.3 L10.3 21 V13.9 Z',
  sort: 'M8.5 20 V4.6 M4.8 8.3 L8.5 4.6 L12.2 8.3 M15.5 4 V19.4 M11.8 15.7 L15.5 19.4 L19.2 15.7',
  download: 'M12 3.6 V14.6 M7.6 10.2 L12 14.6 L16.4 10.2 M4.6 18.6 H19.4',
  upload:
    'M12 16.4 V4.6 M7.4 9.2 L12 4.6 L16.6 9.2 M4.8 15.4 V18.4 A1.6 1.6 0 0 0 6.4 20 H17.6 A1.6 1.6 0 0 0 19.2 18.4 V15.4',
  plus: 'M12 6.4 V17.6 M6.4 12 H17.6',
  close: 'M7 7 L17 17 M17 7 L7 17',
  check: 'M6.8 12.4 L10.4 16 L17.4 8.6',
  // Та же тележка с плюсом и с галочкой в корзине: «положить» и «уже лежит»
  cartPlus:
    'M2.8 4.2 H5.1 L7.3 15.2 H17.6 L19.8 7.6 H6.1 M7.6 19 A1.4 1.4 0 1 0 10.4 19 A1.4 1.4 0 1 0 7.6 19 Z M15 19 A1.4 1.4 0 1 0 17.8 19 A1.4 1.4 0 1 0 15 19 Z M12.9 9 V13.4 M10.7 11.2 H15.1',
  cartCheck:
    'M2.8 4.2 H5.1 L7.3 15.2 H17.6 L19.8 7.6 H6.1 M7.6 19 A1.4 1.4 0 1 0 10.4 19 A1.4 1.4 0 1 0 7.6 19 Z M15 19 A1.4 1.4 0 1 0 17.8 19 A1.4 1.4 0 1 0 15 19 Z M10.4 11.2 L12.3 13 L15.6 9.6',
  trash:
    'M5.4 7.6 H18.6 M7 7.6 L7.9 19.2 A1.6 1.6 0 0 0 9.5 20.6 H14.5 A1.6 1.6 0 0 0 16.1 19.2 L17 7.6 M9.4 7.6 V5.6 A1.2 1.2 0 0 1 10.6 4.4 H13.4 A1.2 1.2 0 0 1 14.6 5.6 V7.6',
  edit: 'M5 19 H8 L18 9 L15 6 L5 16 Z',
  retry: 'M19.4 12 A7.4 7.4 0 1 1 17 6.6 M18.6 3.6 V7.4 H14.8',
  logout:
    'M14.6 7.4 V5.6 A1.9 1.9 0 0 0 12.7 3.7 H6.6 A1.9 1.9 0 0 0 4.7 5.6 V18.4 A1.9 1.9 0 0 0 6.6 20.3 H12.7 A1.9 1.9 0 0 0 14.6 18.4 V16.6 M9.6 12 H20.3 M17.2 8.9 L20.3 12 L17.2 15.1',
  swap: 'M4.6 8.4 H16.4 M13 5 L16.4 8.4 L13 11.8 M19.4 15.6 H7.6 M11 12.2 L7.6 15.6 L11 19',
  // «Избранное» в ките нарисовано закладкой, а не звездой — имя по форме.
  bookmark: 'M6.7 4.4 H17.3 V20.7 L12 16.8 L6.7 20.7 Z',

  // ── Отборы и признаки каталога (сверх кита, 25.09.2026) ─────────────────────
  // Ярлык с люверсом — справочник «Модель»; ползунки — «Параметр» узла. Признаки товара
  // (27.09.2026 — контуром без плашки, смысл читается без подсказки): ценник с процентом —
  // распродажа, рупор — акция, искры — новинка, песочные часы — заказ ждёт подтверждения
  // менеджера («ожидается поставка» — `truck`). Процент на ценнике — точками-кружками:
  // точка нулевой длины на 18px сливалась с косой чертой
  tagPercent:
    'M12.6 3.8 H18.6 A1.6 1.6 0 0 1 20.2 5.4 V11.4 L11.4 20.2 L3.8 12.6 Z M9.4 14.6 L14.6 9.4 M9.2 9.9 A0.7 0.7 0 1 0 10.6 9.9 A0.7 0.7 0 1 0 9.2 9.9 Z M13.4 14.1 A0.7 0.7 0 1 0 14.8 14.1 A0.7 0.7 0 1 0 13.4 14.1 Z',
  megaphone:
    'M4.6 9.6 H7.8 L15.2 5.4 V18.6 L7.8 14.4 H4.6 A0.8 0.8 0 0 1 3.8 13.6 V10.4 A0.8 0.8 0 0 1 4.6 9.6 Z M7.8 14.4 L9 19.2 A0.8 0.8 0 0 0 9.8 19.8 H10.6 A0.6 0.6 0 0 0 11.2 19.1 L10.3 15.8 M18.2 9.2 A3.8 3.8 0 0 1 18.2 14.8',
  sparkles:
    'M10 6.4 C10.5 10.6 12.4 12.5 16.6 13 C12.4 13.5 10.5 15.4 10 19.6 C9.5 15.4 7.6 13.5 3.4 13 C7.6 12.5 9.5 10.6 10 6.4 Z M17.8 3.6 V8.8 M15.2 6.2 H20.4',
  hourglass:
    'M6.8 3.8 H17.2 M6.8 20.2 H17.2 M8 3.8 V6.8 C8 9 9.8 10.6 12 12 C14.2 10.6 16 9 16 6.8 V3.8 M8 20.2 V17.2 C8 15 9.8 13.4 12 12 C14.2 13.4 16 15 16 17.2 V20.2 M10 17.8 L12 16.4 L14 17.8',
  tag: 'M4 12.2 V5.2 A1.2 1.2 0 0 1 5.2 4 H12.2 L20 11.8 A1.3 1.3 0 0 1 20 13.6 L13.6 20 A1.3 1.3 0 0 1 11.8 20 Z M7.6 8.4 A0.9 0.9 0 1 0 9.4 8.4 A0.9 0.9 0 1 0 7.6 8.4 Z',
  sliders:
    'M20 6.4 H14.4 M10.4 6.4 H4 M14.4 4.4 V8.4 M20 12 H12 M8 12 H4 M8 10 V14 M20 17.6 H16.4 M12.4 17.6 H4 M16.4 15.6 V19.6',

  // ── Элементы интерфейса ────────────────────────────────────────────────────
  more: 'M10.3 5.6 A1.7 1.7 0 1 0 13.7 5.6 A1.7 1.7 0 1 0 10.3 5.6 Z M10.3 12 A1.7 1.7 0 1 0 13.7 12 A1.7 1.7 0 1 0 10.3 12 Z M10.3 18.4 A1.7 1.7 0 1 0 13.7 18.4 A1.7 1.7 0 1 0 10.3 18.4 Z',
  menu: 'M4.4 6.4 H19.6 M4.4 12 H19.6 M4.4 17.6 H19.6',
  rows: 'M4.4 5.6 H19.6 M4.4 9.6 H19.6 M4.4 13.6 H19.6 M4.4 17.6 H19.6',
  columns: 'M4.4 5.2 H19.6 V18.8 H4.4 Z M10 5.2 V18.8 M15 5.2 V18.8',
  eye: 'M2.6 12 C5 7.6 8.3 5.4 12 5.4 C15.7 5.4 19 7.6 21.4 12 C19 16.4 15.7 18.6 12 18.6 C8.3 18.6 5 16.4 2.6 12 Z M9.1 12 A2.9 2.9 0 1 0 14.9 12 A2.9 2.9 0 1 0 9.1 12 Z',
  pin: 'M12 20.6 C15.4 16.6 18.4 13.6 18.4 10.2 A6.4 6.4 0 0 0 5.6 10.2 C5.6 13.6 8.6 16.6 12 20.6 Z M9.6 10.2 A2.4 2.4 0 1 0 14.4 10.2 A2.4 2.4 0 1 0 9.6 10.2 Z',
  calendar:
    'M4.6 7.6 A1.6 1.6 0 0 1 6.2 6 H17.8 A1.6 1.6 0 0 1 19.4 7.6 V18.4 A1.6 1.6 0 0 1 17.8 20 H6.2 A1.6 1.6 0 0 1 4.6 18.4 Z M4.6 10.4 H19.4 M8.6 4.4 V7.4 M15.4 4.4 V7.4',
  calendarClock:
    'M4.6 7.6 A1.6 1.6 0 0 1 6.2 6 H17.8 A1.6 1.6 0 0 1 19.4 7.6 V18.4 A1.6 1.6 0 0 1 17.8 20 H6.2 A1.6 1.6 0 0 1 4.6 18.4 Z M4.6 10.4 H19.4 M12 13 V15.6 L14 16.6',
  // Кит рисует стрелки часов без циферблата — он всегда лежит в цветном кружке.
  // Отдельная иконка обязана читаться сама, поэтому окружность включена в глиф.
  clock: 'M3.8 12 A8.2 8.2 0 1 0 20.2 12 A8.2 8.2 0 1 0 3.8 12 Z M12 7.6 V12 L15.2 14',

  // ── Оформление и язык ──────────────────────────────────────────────────────
  // В ките этих глифов нет: шапка кабинета получила выбор темы и языка. Геометрия та же —
  // окружность info/warn/clock (r 8.2), лучи и скругления на сетке 24.
  sun: 'M8 12 A4 4 0 1 0 16 12 A4 4 0 1 0 8 12 Z M12 3.6 V5.6 M12 18.4 V20.4 M3.6 12 H5.6 M18.4 12 H20.4 M6.06 6.06 L7.47 7.47 M16.53 16.53 L17.94 17.94 M6.06 17.94 L7.47 16.53 M16.53 7.47 L17.94 6.06',
  moon: 'M19.6 14.6 A8 8 0 1 1 9.4 4.4 A7.3 7.3 0 0 0 19.6 14.6 Z',
  // «Как в системе»: экран устройства, а не полузалитый круг — заливки у глифов нет вовсе
  monitor:
    'M5.4 5 H18.6 A1.6 1.6 0 0 1 20.2 6.6 V14.4 A1.6 1.6 0 0 1 18.6 16 H5.4 A1.6 1.6 0 0 1 3.8 14.4 V6.6 A1.6 1.6 0 0 1 5.4 5 Z M8.6 19.6 H15.4 M12 16 V19.6',
  globe:
    'M3.8 12 A8.2 8.2 0 1 0 20.2 12 A8.2 8.2 0 1 0 3.8 12 Z M3.8 12 H20.2 M12 3.8 C9.6 6.2 8.4 9 8.4 12 C8.4 15 9.6 17.8 12 20.2 C14.4 17.8 15.6 15 15.6 12 C15.6 9 14.4 6.2 12 3.8 Z',

  // ── Обратная связь ─────────────────────────────────────────────────────────
  info: 'M3.8 12 A8.2 8.2 0 1 0 20.2 12 A8.2 8.2 0 1 0 3.8 12 Z M12 11 V16.6 M12 7.6 V7.9',
  warn: 'M3.8 12 A8.2 8.2 0 1 0 20.2 12 A8.2 8.2 0 1 0 3.8 12 Z M12 7.4 V13.2 M12 16.4 V16.7',

  // ── Направление ────────────────────────────────────────────────────────────
  chevronUp: 'M7 14 L12 9 L17 14',
  chevronDown: 'M7 10 L12 15 L17 10',
  chevronLeft: 'M14 6.4 L8.6 12 L14 17.6',
  chevronRight: 'M10 6.4 L15.4 12 L10 17.6',
  arrowUp: 'M12 19 V6.4 M7.6 10.8 L12 6.4 L16.4 10.8',
  arrowDown: 'M12 5 V17.6 M7.6 13.2 L12 17.6 L16.4 13.2',
  // Свернуть / развернуть боковую панель: рамка окна с колонкой слева и шеврон в ней.
  // Свой глиф взамен «шеврона к упору» из макета «Каталог (standalone)» 65, 87 — тот на 14px
  // читался как обрывок стрелки.
  panelCollapse:
    'M5.4 5.4 H18.6 A1.6 1.6 0 0 1 20.2 7 V17 A1.6 1.6 0 0 1 18.6 18.6 H5.4 A1.6 1.6 0 0 1 3.8 17 V7 A1.6 1.6 0 0 1 5.4 5.4 Z M9.4 5.4 V18.6 M16 10 L14 12 L16 14',
  panelExpand:
    'M5.4 5.4 H18.6 A1.6 1.6 0 0 1 20.2 7 V17 A1.6 1.6 0 0 1 18.6 18.6 H5.4 A1.6 1.6 0 0 1 3.8 17 V7 A1.6 1.6 0 0 1 5.4 5.4 Z M9.4 5.4 V18.6 M14 10 L16 12 L14 14',
  // Сортировка колонки не задана: двойной шеврон. Источник — «Каталог (standalone)» arrowPath
  sortable: 'M9.4 9.6 L12 7 L14.6 9.6 M9.4 14.4 L12 17 L14.6 14.4',
} as const

export type IconName = keyof typeof ICON_PATHS

/** Порядок объявления в карте = порядок показа на стенде. */
export const ICON_NAMES = // ключи карты и есть IconName: тип выведен из неё же, Object.keys теряет это сужение
  Object.keys(ICON_PATHS) as IconName[]
